module.exports = __webpack_public_path__ + "static/media/bg_fx.3ce036a6.png";